import script from "./ParkOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./ParkOrders.vue?vue&type=script&setup=true&lang=js"

import "./ParkOrders.vue?vue&type=style&index=0&id=5517d959&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5517d959"]])

export default __exports__